import type { LucideIcon } from "lucide-react"
import {
  Facebook,
  Globe,
  Instagram,
  Linkedin,
  MessageCircle,
  Share2,
  Youtube,
} from "lucide-react"

export const SOCIAL_PLATFORMS = [
  "facebook",
  "instagram",
  "x",
  "linkedin",
  "youtube",
  "tiktok",
  "whatsapp",
  "pinterest",
  "snapchat",
  "threads",
  "website",
  "other",
] as const

export type SocialPlatform = (typeof SOCIAL_PLATFORMS)[number]

export interface SocialLink {
  platform: SocialPlatform | string
  url: string
}

export const SOCIAL_PLATFORM_LABELS: Record<SocialPlatform, string> = {
  facebook: "Facebook",
  instagram: "Instagram",
  x: "X (Twitter)",
  linkedin: "LinkedIn",
  youtube: "YouTube",
  tiktok: "TikTok",
  whatsapp: "WhatsApp",
  pinterest: "Pinterest",
  snapchat: "Snapchat",
  threads: "Threads",
  website: "Website",
  other: "Other",
}

const PLATFORM_ICONS: Partial<Record<SocialPlatform, LucideIcon>> = {
  facebook: Facebook,
  instagram: Instagram,
  x: Share2,
  linkedin: Linkedin,
  youtube: Youtube,
  whatsapp: MessageCircle,
  website: Globe,
  other: Share2,
}

export function getSocialPlatformIcon(platform: string): LucideIcon {
  const key = platform.toLowerCase() as SocialPlatform
  return PLATFORM_ICONS[key] ?? Share2
}

export function getSocialPlatformLabel(platform: string): string {
  const key = platform.toLowerCase() as SocialPlatform
  return SOCIAL_PLATFORM_LABELS[key] ?? platform
}

export function isValidSocialUrl(url: string): boolean {
  try {
    const parsed = new URL(url)
    return parsed.protocol === "http:" || parsed.protocol === "https:"
  } catch {
    return false
  }
}
